import Axios from 'axios';
import { format } from 'date-fns';
import { nl, fr } from 'date-fns/locale';

import translationApi from '@/api/translation.api';
import { defineStore } from 'pinia';

export const useRootStore = defineStore('root', {
  state: () => ({
    lang: 'nl',
    translations: {},
    config: {
      loaded: false,
      googleTagManagerContainer: undefined,
      instrumentationKey: undefined,
      useCookiebot: undefined,
      allowStartBankenFlow: undefined,
      allowAnonymous: undefined,
      allowLoginWithItsme: undefined
    },
    error: undefined,
    isMobile: undefined
  }),
  getters: {
    translationsLoaded: (state) => Object.keys(state.translations).length > 0,
    configLoaded: (state) => state.config.loaded,
    rootDataLoaded(state) {
      return state.configLoaded && state.translationsLoaded;
    },
    translate: (state) => (key) => state && state.translations[key] ? state.translations[key] : key,
    ISOLanguage: (state) => state.lang + '-BE',
    xeriusHomeUrl: (state) =>
      state.lang === 'fr' ? 'https://www.xerius.be/fr-be' : 'https://www.xerius.be/nl-be',
    getPrijsString: (state) => (prijs) =>
      new Intl.NumberFormat(state.ISOLanguage, { style: 'currency', currency: 'EUR' }).format(
        prijs
      ),
    getDatumString: (state) => (datum) =>
      state.lang === 'fr'
        ? format(new Date(datum), 'dd MMMM yyyy', { locale: fr })
        : format(new Date(datum), 'dd MMMM yyyy', { locale: nl }),
    juridischeInformatieUrl: (state) =>
      state.lang === 'fr'
        ? 'https://www.xerius.be/fr-be/footer/informations-juridiques'
        : 'https://www.xerius.be/nl-be/footer/juridische-informatie',
    cookieInformatieUrl: (state) =>
      state.lang === 'fr'
        ? 'https://www.xerius.be/fr-be/footer/declaration-en-matiere-de-cookies'
        : 'https://www.xerius.be/nl-be/footer/cookie-verklaring'
  },
  actions: {
    loadConfig() {
      return Axios.get(`${process.env.VUE_APP_PUBLIC_PATH}config.json`, {
        headers: { 'Cache-Control': 'no-cache' }
      }).then((res) => this.setConfig(res.data));
    },
    loadTranslations(lang) {
      this.translations = {};
      const currentLang = lang ? lang : this.lang;
      return translationApi
        .get(currentLang)
        .then((translations) => (this.translations = translations));
    },
    handleRouteChangeLangChange(lang) {
      if (!lang) {
        lang = this.lang;
      }
      const languageChanged = lang !== this.lang;

      if (languageChanged || !this.translationsLoaded) {
        this.lang = lang;
        document.documentElement.setAttribute('lang', lang);
        return this.loadTranslations(lang);
      }
    },
    setConfig(runtimeConfig) {
      this.config = { ...this.config, ...runtimeConfig };
      this.config.loaded = true;
    },
    setErrorInternalServer() {
      this.error = {
        statusCode: 500,
        component: 'XerOeps'
      };
    },
    setErrorUnauthorised() {
      this.error = {
        statusCode: 401,
        component: 'XerUnauthorized'
      };
    },
    setErrorNotFound() {
      this.error = {
        statusCode: 404,
        component: 'XerNotFound'
      };
    },
    setErrorLoggedOut(props) {
      this.error = {
        statusCode: 401,
        component: 'XerLogin',
        props: props
      };
    },
    setIsMobile(value) {
      this.isMobile = value;
    }
  }
});
